<style src="./NewOccupation.scss" lang="scss" scoped></style>
<template lang="html">
  <section class="new-occupation right-panel-box" v-click-outside="closePanel">
    <span class="panel-title">Nova Ocupação</span>

    <form v-on:submit.prevent="addNew">
      <textbox
        label="Nome da ocupação"
        placeholder="Ex.: Coordenador"
        v-model="occupationName" />

      <div class="comandos">
        <button class="btn-success" :enabled="saveDisabled"><icon-check />Salvar</button>
        <button
          type="button"
          class="btn-danger"
          v-shortkey="['esc']" @shortkey="cancel"
          @click="cancel"><icon-close />Cancelar</button>
      </div>
    </form>
  </section>
</template>

<script>
import { Textbox } from '@/components/primitives'
import {IconCheck, IconClose} from '@/components/primitives/icons'
import { AddNewOccupation } from '@/brain/record/occupation'

export default {
  name: 'Occupation',
  components: {
    Textbox,
    IconCheck,
    IconClose
  },
  data () {
    return {
      saveDisabled: false,
      occupationName: ''
    }
  },
  methods: {
    addNew () {
      this.saveDisabled = true
      AddNewOccupation({ name: this.occupationName })
        .then((response) => {
          this.saveDisabled = false
          this.$emit('success')
          this.occupationName = ''
        })
    },
    closePanel () {
      this.$emit('cancel')
    },
    cancel (e) {
      e.stopPropagation()
      this.closePanel()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/record/occupation/right-panel/new-occupation/NewOccupation.vue